/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Account API
 * This API is for managing Accounts, Organizations and Workspaces.
 * OpenAPI spec version: 1.1.9
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateWorkspaceDto,
  UpdateWorkspaceDto,
  WorkspacesControllerCreate201,
  WorkspacesControllerCreate400,
  WorkspacesControllerCreate403,
  WorkspacesControllerDelete404,
  WorkspacesControllerGet200,
  WorkspacesControllerGet404,
  WorkspacesControllerGetAll200,
  WorkspacesControllerGetAllParams,
  WorkspacesControllerUpdate200,
  WorkspacesControllerUpdate400,
  WorkspacesControllerUpdate404
} from '../../schemas';

import { customFetch } from '../../../../../clients/customInstance';
import type { ErrorType } from '../../../../../clients/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get all workspaces paginated
 * @summary Get all workspaces
 */
export type workspacesControllerGetAllResponse200 = {
  data: WorkspacesControllerGetAll200
  status: 200
}

export type workspacesControllerGetAllResponseSuccess = (workspacesControllerGetAllResponse200) & {
  headers: Headers;
};
;

export type workspacesControllerGetAllResponse = (workspacesControllerGetAllResponseSuccess)

export const getWorkspacesControllerGetAllUrl = (accountId: string,
    params?: WorkspacesControllerGetAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/accounts/${accountId}/workspaces?${stringifiedParams}` : `/accounts/${accountId}/workspaces`
}

export const workspacesControllerGetAll = async (accountId: string,
    params?: WorkspacesControllerGetAllParams, options?: RequestInit): Promise<workspacesControllerGetAllResponse> => {
  
  return customFetch<workspacesControllerGetAllResponse>(getWorkspacesControllerGetAllUrl(accountId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getWorkspacesControllerGetAllQueryKey = (accountId: string,
    params?: WorkspacesControllerGetAllParams,) => {
    return [
    `/accounts/${accountId}/workspaces`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getWorkspacesControllerGetAllQueryOptions = <TData = Awaited<ReturnType<typeof workspacesControllerGetAll>>, TError = ErrorType<unknown>>(accountId: string,
    params?: WorkspacesControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGetAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspacesControllerGetAllQueryKey(accountId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesControllerGetAll>>> = ({ signal }) => workspacesControllerGetAll(accountId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGetAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspacesControllerGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesControllerGetAll>>>
export type WorkspacesControllerGetAllQueryError = ErrorType<unknown>


export function useWorkspacesControllerGetAll<TData = Awaited<ReturnType<typeof workspacesControllerGetAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params: undefined |  WorkspacesControllerGetAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGetAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesControllerGetAll>>,
          TError,
          Awaited<ReturnType<typeof workspacesControllerGetAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesControllerGetAll<TData = Awaited<ReturnType<typeof workspacesControllerGetAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params?: WorkspacesControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGetAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesControllerGetAll>>,
          TError,
          Awaited<ReturnType<typeof workspacesControllerGetAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesControllerGetAll<TData = Awaited<ReturnType<typeof workspacesControllerGetAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params?: WorkspacesControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGetAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all workspaces
 */

export function useWorkspacesControllerGetAll<TData = Awaited<ReturnType<typeof workspacesControllerGetAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params?: WorkspacesControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGetAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspacesControllerGetAllQueryOptions(accountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Create a new workspace with the provided data
 * @summary Create a new workspace
 */
export type workspacesControllerCreateResponse201 = {
  data: WorkspacesControllerCreate201
  status: 201
}

export type workspacesControllerCreateResponse400 = {
  data: WorkspacesControllerCreate400
  status: 400
}

export type workspacesControllerCreateResponse403 = {
  data: WorkspacesControllerCreate403
  status: 403
}

export type workspacesControllerCreateResponseSuccess = (workspacesControllerCreateResponse201) & {
  headers: Headers;
};
export type workspacesControllerCreateResponseError = (workspacesControllerCreateResponse400 | workspacesControllerCreateResponse403) & {
  headers: Headers;
};

export type workspacesControllerCreateResponse = (workspacesControllerCreateResponseSuccess | workspacesControllerCreateResponseError)

export const getWorkspacesControllerCreateUrl = (accountId: string,) => {


  

  return `/accounts/${accountId}/workspaces`
}

export const workspacesControllerCreate = async (accountId: string,
    createWorkspaceDto: CreateWorkspaceDto, options?: RequestInit): Promise<workspacesControllerCreateResponse> => {
  
  return customFetch<workspacesControllerCreateResponse>(getWorkspacesControllerCreateUrl(accountId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createWorkspaceDto,)
  }
);}
  



export const getWorkspacesControllerCreateMutationOptions = <TError = ErrorType<WorkspacesControllerCreate400 | WorkspacesControllerCreate403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerCreate>>, TError,{accountId: string;data: CreateWorkspaceDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerCreate>>, TError,{accountId: string;data: CreateWorkspaceDto}, TContext> => {

const mutationKey = ['workspacesControllerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspacesControllerCreate>>, {accountId: string;data: CreateWorkspaceDto}> = (props) => {
          const {accountId,data} = props ?? {};

          return  workspacesControllerCreate(accountId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type WorkspacesControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof workspacesControllerCreate>>>
    export type WorkspacesControllerCreateMutationBody = CreateWorkspaceDto
    export type WorkspacesControllerCreateMutationError = ErrorType<WorkspacesControllerCreate400 | WorkspacesControllerCreate403>

    /**
 * @summary Create a new workspace
 */
export const useWorkspacesControllerCreate = <TError = ErrorType<WorkspacesControllerCreate400 | WorkspacesControllerCreate403>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerCreate>>, TError,{accountId: string;data: CreateWorkspaceDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workspacesControllerCreate>>,
        TError,
        {accountId: string;data: CreateWorkspaceDto},
        TContext
      > => {
      return useMutation(getWorkspacesControllerCreateMutationOptions(options), queryClient);
    }
    /**
 * Get a workspace by id
 * @summary Get a workspace by id
 */
export type workspacesControllerGetResponse200 = {
  data: WorkspacesControllerGet200
  status: 200
}

export type workspacesControllerGetResponse404 = {
  data: WorkspacesControllerGet404
  status: 404
}

export type workspacesControllerGetResponseSuccess = (workspacesControllerGetResponse200) & {
  headers: Headers;
};
export type workspacesControllerGetResponseError = (workspacesControllerGetResponse404) & {
  headers: Headers;
};

export type workspacesControllerGetResponse = (workspacesControllerGetResponseSuccess | workspacesControllerGetResponseError)

export const getWorkspacesControllerGetUrl = (accountId: string,
    workspaceId: string,) => {


  

  return `/accounts/${accountId}/workspaces/${workspaceId}`
}

export const workspacesControllerGet = async (accountId: string,
    workspaceId: string, options?: RequestInit): Promise<workspacesControllerGetResponse> => {
  
  return customFetch<workspacesControllerGetResponse>(getWorkspacesControllerGetUrl(accountId,workspaceId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getWorkspacesControllerGetQueryKey = (accountId: string,
    workspaceId: string,) => {
    return [
    `/accounts/${accountId}/workspaces/${workspaceId}`
    ] as const;
    }

    
export const getWorkspacesControllerGetQueryOptions = <TData = Awaited<ReturnType<typeof workspacesControllerGet>>, TError = ErrorType<WorkspacesControllerGet404>>(accountId: string,
    workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspacesControllerGetQueryKey(accountId,workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspacesControllerGet>>> = ({ signal }) => workspacesControllerGet(accountId,workspaceId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(accountId && workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspacesControllerGetQueryResult = NonNullable<Awaited<ReturnType<typeof workspacesControllerGet>>>
export type WorkspacesControllerGetQueryError = ErrorType<WorkspacesControllerGet404>


export function useWorkspacesControllerGet<TData = Awaited<ReturnType<typeof workspacesControllerGet>>, TError = ErrorType<WorkspacesControllerGet404>>(
 accountId: string,
    workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesControllerGet>>,
          TError,
          Awaited<ReturnType<typeof workspacesControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesControllerGet<TData = Awaited<ReturnType<typeof workspacesControllerGet>>, TError = ErrorType<WorkspacesControllerGet404>>(
 accountId: string,
    workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspacesControllerGet>>,
          TError,
          Awaited<ReturnType<typeof workspacesControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspacesControllerGet<TData = Awaited<ReturnType<typeof workspacesControllerGet>>, TError = ErrorType<WorkspacesControllerGet404>>(
 accountId: string,
    workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a workspace by id
 */

export function useWorkspacesControllerGet<TData = Awaited<ReturnType<typeof workspacesControllerGet>>, TError = ErrorType<WorkspacesControllerGet404>>(
 accountId: string,
    workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspacesControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspacesControllerGetQueryOptions(accountId,workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Update an existing workspace with the provided data
 * @summary Update a workspace
 */
export type workspacesControllerUpdateResponse200 = {
  data: WorkspacesControllerUpdate200
  status: 200
}

export type workspacesControllerUpdateResponse400 = {
  data: WorkspacesControllerUpdate400
  status: 400
}

export type workspacesControllerUpdateResponse404 = {
  data: WorkspacesControllerUpdate404
  status: 404
}

export type workspacesControllerUpdateResponseSuccess = (workspacesControllerUpdateResponse200) & {
  headers: Headers;
};
export type workspacesControllerUpdateResponseError = (workspacesControllerUpdateResponse400 | workspacesControllerUpdateResponse404) & {
  headers: Headers;
};

export type workspacesControllerUpdateResponse = (workspacesControllerUpdateResponseSuccess | workspacesControllerUpdateResponseError)

export const getWorkspacesControllerUpdateUrl = (accountId: string,
    workspaceId: string,) => {


  

  return `/accounts/${accountId}/workspaces/${workspaceId}`
}

export const workspacesControllerUpdate = async (accountId: string,
    workspaceId: string,
    updateWorkspaceDto: UpdateWorkspaceDto, options?: RequestInit): Promise<workspacesControllerUpdateResponse> => {
  
  return customFetch<workspacesControllerUpdateResponse>(getWorkspacesControllerUpdateUrl(accountId,workspaceId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateWorkspaceDto,)
  }
);}
  



export const getWorkspacesControllerUpdateMutationOptions = <TError = ErrorType<WorkspacesControllerUpdate400 | WorkspacesControllerUpdate404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerUpdate>>, TError,{accountId: string;workspaceId: string;data: UpdateWorkspaceDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerUpdate>>, TError,{accountId: string;workspaceId: string;data: UpdateWorkspaceDto}, TContext> => {

const mutationKey = ['workspacesControllerUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspacesControllerUpdate>>, {accountId: string;workspaceId: string;data: UpdateWorkspaceDto}> = (props) => {
          const {accountId,workspaceId,data} = props ?? {};

          return  workspacesControllerUpdate(accountId,workspaceId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type WorkspacesControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof workspacesControllerUpdate>>>
    export type WorkspacesControllerUpdateMutationBody = UpdateWorkspaceDto
    export type WorkspacesControllerUpdateMutationError = ErrorType<WorkspacesControllerUpdate400 | WorkspacesControllerUpdate404>

    /**
 * @summary Update a workspace
 */
export const useWorkspacesControllerUpdate = <TError = ErrorType<WorkspacesControllerUpdate400 | WorkspacesControllerUpdate404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerUpdate>>, TError,{accountId: string;workspaceId: string;data: UpdateWorkspaceDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workspacesControllerUpdate>>,
        TError,
        {accountId: string;workspaceId: string;data: UpdateWorkspaceDto},
        TContext
      > => {
      return useMutation(getWorkspacesControllerUpdateMutationOptions(options), queryClient);
    }
    /**
 * Soft delete a workspace by id
 * @summary Delete a workspace
 */
export type workspacesControllerDeleteResponse204 = {
  data: void
  status: 204
}

export type workspacesControllerDeleteResponse404 = {
  data: WorkspacesControllerDelete404
  status: 404
}

export type workspacesControllerDeleteResponseSuccess = (workspacesControllerDeleteResponse204) & {
  headers: Headers;
};
export type workspacesControllerDeleteResponseError = (workspacesControllerDeleteResponse404) & {
  headers: Headers;
};

export type workspacesControllerDeleteResponse = (workspacesControllerDeleteResponseSuccess | workspacesControllerDeleteResponseError)

export const getWorkspacesControllerDeleteUrl = (accountId: string,
    workspaceId: string,) => {


  

  return `/accounts/${accountId}/workspaces/${workspaceId}`
}

export const workspacesControllerDelete = async (accountId: string,
    workspaceId: string, options?: RequestInit): Promise<workspacesControllerDeleteResponse> => {
  
  return customFetch<workspacesControllerDeleteResponse>(getWorkspacesControllerDeleteUrl(accountId,workspaceId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getWorkspacesControllerDeleteMutationOptions = <TError = ErrorType<WorkspacesControllerDelete404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerDelete>>, TError,{accountId: string;workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerDelete>>, TError,{accountId: string;workspaceId: string}, TContext> => {

const mutationKey = ['workspacesControllerDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspacesControllerDelete>>, {accountId: string;workspaceId: string}> = (props) => {
          const {accountId,workspaceId} = props ?? {};

          return  workspacesControllerDelete(accountId,workspaceId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type WorkspacesControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof workspacesControllerDelete>>>
    
    export type WorkspacesControllerDeleteMutationError = ErrorType<WorkspacesControllerDelete404>

    /**
 * @summary Delete a workspace
 */
export const useWorkspacesControllerDelete = <TError = ErrorType<WorkspacesControllerDelete404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerDelete>>, TError,{accountId: string;workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workspacesControllerDelete>>,
        TError,
        {accountId: string;workspaceId: string},
        TContext
      > => {
      return useMutation(getWorkspacesControllerDeleteMutationOptions(options), queryClient);
    }
    export type workspacesControllerHardDeleteResponse204 = {
  data: void
  status: 204
}

export type workspacesControllerHardDeleteResponseSuccess = (workspacesControllerHardDeleteResponse204) & {
  headers: Headers;
};
;

export type workspacesControllerHardDeleteResponse = (workspacesControllerHardDeleteResponseSuccess)

export const getWorkspacesControllerHardDeleteUrl = (accountId: string,
    workspaceId: string,) => {


  

  return `/accounts/${accountId}/workspaces/${workspaceId}/hard`
}

export const workspacesControllerHardDelete = async (accountId: string,
    workspaceId: string, options?: RequestInit): Promise<workspacesControllerHardDeleteResponse> => {
  
  return customFetch<workspacesControllerHardDeleteResponse>(getWorkspacesControllerHardDeleteUrl(accountId,workspaceId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getWorkspacesControllerHardDeleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerHardDelete>>, TError,{accountId: string;workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerHardDelete>>, TError,{accountId: string;workspaceId: string}, TContext> => {

const mutationKey = ['workspacesControllerHardDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspacesControllerHardDelete>>, {accountId: string;workspaceId: string}> = (props) => {
          const {accountId,workspaceId} = props ?? {};

          return  workspacesControllerHardDelete(accountId,workspaceId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type WorkspacesControllerHardDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof workspacesControllerHardDelete>>>
    
    export type WorkspacesControllerHardDeleteMutationError = ErrorType<unknown>

    export const useWorkspacesControllerHardDelete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspacesControllerHardDelete>>, TError,{accountId: string;workspaceId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workspacesControllerHardDelete>>,
        TError,
        {accountId: string;workspaceId: string},
        TContext
      > => {
      return useMutation(getWorkspacesControllerHardDeleteMutationOptions(options), queryClient);
    }
    